import { Route, RouteObject } from 'react-router-dom';
import OutstandingLandingPage from './components/landing/landing';
import { OutstandingAccountDetailPage } from './components/details/details';
  

export interface outstandingRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: outstandingRoute[];
}

export const outstandingRoutes: outstandingRoute[] = [
  {
      path: 'cx/outstanding',
      element: <OutstandingLandingPage />,
    },
    {
      path: 'cx/outstanding/:consumerNumber',
      element: <OutstandingAccountDetailPage />,
    }
];
